module.exports = __webpack_public_path__ + "img/illus_confirm_email@2x.10c7254a.png";